import { render, staticRenderFns } from "./TemplateCreatePage.vue?vue&type=template&id=5c5e40bc&scoped=true"
import script from "./TemplateCreatePage.vue?vue&type=script&lang=js"
export * from "./TemplateCreatePage.vue?vue&type=script&lang=js"
import style0 from "./TemplateCreatePage.vue?vue&type=style&index=0&id=5c5e40bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5e40bc",
  null
  
)

export default component.exports